import { render, staticRenderFns } from "./RComparisonChart.vue?vue&type=template&id=50c4b19d&scoped=true&"
import script from "./RComparisonChart.vue?vue&type=script&lang=js&"
export * from "./RComparisonChart.vue?vue&type=script&lang=js&"
import style0 from "./RComparisonChart.vue?vue&type=style&index=0&id=50c4b19d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c4b19d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VIcon,VRow,VSkeletonLoader})
